import { Box, styled } from '@mui/material';

/** 레거시 마크업의 .text-center 만 보충 */
export const VehicleCostRoot = styled(Box)`
  & .text-center {
    text-align: center;
  }
`;
